// Virtual "All Friends" group — not stored in DB; represented as is_everyone flag on tee_times.
// The constant is still called EVERYONE_GROUP and the DB flag is still is_everyone — only the
// user-facing copy was renamed in v69. Renaming the internal identifiers would touch 80+ files
// for no functional benefit.
export const EVERYONE_GROUP = {
  id: '__everyone',
  name: 'All Friends',
  emoji: '🌐',
  color: '#1a5c32',
  description: 'All your friends — automatically updated as your network grows.',
  isVirtual: true,
};

// Virtual "App-Wide" group — not stored in DB; represented as is_app_wide flag on tee_times.
// Used for discovery: shows the tee time to any Greentime user within their App-Wide radius.
// No notifications fire — this is a passive, location-based discovery feature.
export const APP_WIDE_GROUP = {
  id: '__app_wide',
  name: 'App-Wide',
  emoji: '📡',
  color: '#7a5a0a',
  description: 'Any Greentime user nearby can see this tee time. Discovery-only — no notifications sent.',
  isVirtual: true,
};
